module.exports = __webpack_public_path__ + "static/img/baccarat2_en.4381585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/baccarat2_en.png
// module id = gXDd
// module chunks = 1